import decodeBase64 from './decodeBase64';
import getLength from './getLength';
import buildByteArray from './buildByteArray';
import createBlob from './createBlob';

const base64ToBlob = base64String => {
  const decodedString = decodeBase64(base64String);
  const decodedStringLength = getLength(decodedString);
  const byteArray = buildByteArray(decodedString, decodedStringLength);
  return byteArray ? createBlob(byteArray) : null;
};

export default base64ToBlob;



// WEBPACK FOOTER //
// ./src/lib/helpers/PDFHelpers/base64ToBlob.js